import { render, staticRenderFns } from "./VulnSourceOSVAdvisories.vue?vue&type=template&id=671db9d1&"
import script from "./VulnSourceOSVAdvisories.vue?vue&type=script&lang=js&"
export * from "./VulnSourceOSVAdvisories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('671db9d1')) {
      api.createRecord('671db9d1', component.options)
    } else {
      api.reload('671db9d1', component.options)
    }
    module.hot.accept("./VulnSourceOSVAdvisories.vue?vue&type=template&id=671db9d1&", function () {
      api.rerender('671db9d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/vuln-sources/VulnSourceOSVAdvisories.vue"
export default component.exports